import { DatabaseManufacturer } from "../../Api/Database";
import { useState } from "react";

import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";


const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `2px solid rgba(0, 0, 0, 0.03)`,
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  }));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "2px solid rgba(0, 0, 0, 0.03)",
  }));

export interface ManufacturerAccordionProps {
    manufacturer: DatabaseManufacturer
    delete: () => Promise<boolean>
}

export default function ManufacturerAccordion(props: ManufacturerAccordionProps) {

    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);

    const handleChange = () => () => {
      setExpanded(!expanded);
    };

    return (
        <Accordion
            expanded={expanded}
            onChange={handleChange()}
            key={"credential_info_" + props.manufacturer.id}
            sx={{ width: "100%" , backgroundColor:"gainsboro" ,marginTop:"15px"}}
            id={"credential_info_" + props.manufacturer.id}
            
        >
            <MuiAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ minHeight: "38px" }}
            >
            <Typography sx={{ fontSize: "16px", fontWeight: "550" }}>
                {props.manufacturer.name}
            </Typography>
            </MuiAccordionSummary>
            <AccordionDetails  
            sx={{ backgroundColor:"white"}}>
            <div> 
                 
                <div className="product-details">
                    <h2 className="sub-title">MANUFACTURER ID: </h2><p>{props.manufacturer.id}</p>
                    <h2 className="sub-title">OFFICIAL NAME: </h2><p>{props.manufacturer.name}</p>
                    <h2 className="sub-title">OFFICIAL WEBSITE: </h2><a href={props.manufacturer.website_url} target="_blank">{props.manufacturer.website_url}</a>
                    <h2 className="sub-title">SUMMARY: </h2><p>{props.manufacturer.summary}</p>
                    <h2 className="sub-title">LOCATION (COUNTRY): </h2><p>{props.manufacturer.location}</p>
                    <h2 className="sub-title">LOCATION ISO: </h2><p>{props.manufacturer.location_iso !== "" ? props.manufacturer.location_iso : "N/A"}</p>
                    <h2 className="sub-title">BUSINESS REGISTRY INFO: </h2><p>{props.manufacturer.business_registry_info !== "" ? <a href={props.manufacturer.business_registry_info} target="_blank">{props.manufacturer.business_registry_info}</a> : "N/A"}</p>
                    <h2 className="sub-title">EORI: </h2><p>{props.manufacturer.eori !== "" ? props.manufacturer.eori : "N/A"}</p>
                    <h2 className="sub-title">LOGO: </h2> 
                    <img src={props.manufacturer.logo} alt={props.manufacturer.name} height="auto" width="150px"/>
                </div>

                <div style={{marginTop:"10px",paddingBottom:"19px"}}>
                    <button className="form_btn" onClick={() => {
                        props.delete().then(deleted => {
                            if(deleted) {
                                setExpanded(false);
                                document.getElementById("credential_info_" + props.manufacturer.id)?.remove();
                            }
                        })
                    }}>Delete</button>
                    <button className="form_btn" onClick={() => {
                        navigate('/edit/manufacturer/' + props.manufacturer.id);
                    }}>Edit</button>
                </div>
            </div>
            </AccordionDetails>
        </Accordion>
    )
}